// extracted by css-extract-rspack-plugin
var _1 = "src-pages-Privacy-module__privacy-yFZNB3";
export { _1 as "privacy" }

    if(module.hot) {
      (function() {
        var localsJsonString = "{\"privacy\":\"src-pages-Privacy-module__privacy-yFZNB3\"}";
        // 1752373455071
        var cssReload = require("../../node_modules/.pnpm/@rspack+core@1.4.6_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  